export default __webpack_public_path__ + "static/media/007-berlin cathedral.0cb56d41.svg";